module.exports = __webpack_public_path__ + "img/login4.1cf3f69e.png";